import { createAction, props } from '@ngrx/store';
import { Activity, User } from './users.model';

// fetch 
export const fetchuserlistData = createAction('[Data] fetch userlist');
export const fetchuserlistSuccess = createAction('[Data] fetch userlist success', props<{ UserListdata: User[] }>())
export const fetchuserlistFail = createAction('[Data fetch userlist failed]', props<{ error: string }>())

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records user'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records user success', 
    props<{ listData: User[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records user failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record user',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record user success', 
    props<{ singleData: User }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record user failure', 
    props<{ error: string }>()
);


// fetch activities
export const fetchActivities = createAction(
    '[Data] fetch records user activities',
    props<{id: string}>()
);
export const fetchActivitiesSuccess = createAction(
    '[Data] fetch records user activities success', 
    props<{ activities: Activity[], totalActivity: number }>()
);
export const fetchActivitiesFail = createAction(
    '[Data] fetch records user activities failure', 
    props<{ activity_error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record user',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record user success'
);
export const addRecordFailure = createAction(
    '[Data] Add record user failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record user',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record user success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record user failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record user',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record user success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record user failure',
    props<{ error: string }>()
);

//Reset Invitation
export const resendInvitation = createAction(
    '[Data] Resend invitation',
    props<{ id: string }>()
);
export const resendInvitationSuccess = createAction(
    '[Data] Resend invitation success'
);
export const resendInvitationFailure = createAction(
    '[Data] Resend invitation failure',
    props<{ error: string }>()
);


//Login As User
export const loginAsUser = createAction(
    '[Data] Login as user',
    props<{ id: string }>()
);
export const loginAsUserSuccess = createAction(
    '[Data] Login as user success'
);
export const loginAsUserFailure = createAction(
    '[Data] Login as user failure',
    props<{ error: string }>()
);


//Reset Two Factor
export const resetTwoFactor = createAction(
    '[Data] Reset Two Factor',
    props<{ id: string }>()
);
export const resetTwoFactorSuccess = createAction(
    '[Data] Reset Two Factor success'
);
export const resetTwoFactorFailure = createAction(
    '[Data] Reset Two Factor failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state user',
);
